// lib/daimon/continuity.client.ts
import type { DaimonConversationRequest } from '#types/types';

/** One inventory boundary for saved Daimon conversations, with ordered explicit selections. */
export function createDaimonConversationClient(userId: () => string | null | undefined, request: typeof fetch = (...args) => fetch(...args)) {
  let selections: Promise<unknown> = Promise.resolve();
  return (body: DaimonConversationRequest): Promise<Response> => {
    const owner = userId();
    const run = async () => {
      if (!owner || owner !== userId()) throw new Error('The account changed before the conversation request.');
      const query = body.action === 'current' ? '?current=true'
        : body.action === 'history' ? `?sessionId=${encodeURIComponent(body.sessionId ?? '')}`
          : body.action === 'subject' ? `?subject=${encodeURIComponent(`${body.subject?.entityType}:${body.subject?.entityId}`)}${body.activeId ? `&active=${encodeURIComponent(body.activeId)}` : ''}` : '';
      return request(`/api/daimon/conversations${query}`, query ? { cache: 'no-store' } : {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
      });
    };
    if (!['select', 'lookup', 'create'].includes(body.action)) return run();
    const result = selections.then(run, run);
    selections = result.catch(() => undefined);
    return result;
  };
}
